import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CartItem } from 'src/app/types/cart';

@Component({
  selector: 'app-cart-item',
  templateUrl: './cart-item.component.html',
  styleUrls: ['./cart-item.component.scss'],
})
export class CartItemComponent implements OnInit {
  @Input() item: CartItem | null = null;
  @Input() disabled: boolean = false;

  @Output() itemRemoveClick = new EventEmitter<void>();
  @Output() increasedAmount = new EventEmitter<void>();
  @Output() decreasedAmount = new EventEmitter<void>();

  constructor() {}

  ngOnInit() {
    return;
  }
}
